export const SIAE_STATUS_EMPTY = '';
export const SIAE_STATUS_APPROVED = 'approved';
export const SIAE_STATUS_EXCLUDED = 'excluded';

export type SiaeStatus = typeof SIAE_STATUS_EMPTY | typeof SIAE_STATUS_APPROVED | typeof SIAE_STATUS_EXCLUDED;

export interface RegulationSettingsValue {
  allows18App?: boolean;
  needsUserVerified?: boolean;
  siaeStatus?: SiaeStatus;
  abbonamentoId?: string | null;
  excludeFromC1?: boolean;
}

export interface RegulationSettingsErrors {
  siaeStatus?: string;
  abbonamentoId?: string;
  allows18App?: string;
}

export interface RegulationSettingsSectionProps {
  value: RegulationSettingsValue;
  onChange: (patch: Partial<RegulationSettingsValue>) => void;
  open: boolean;
  onToggleOpen: () => void;
  disabled?: boolean;
  /**
   * SIAE parity: Carta Cultura and the "Approved" status require a paid offer, so both are frozen
   * when the offer price is 0 (admin greys `allows18App` / `isSiaeApproved` for free offers). The
   * value is left untouched — raising the price back above 0 restores editability with the prior
   * selection intact; the save mapper coerces the payload to false while the price is 0.
   */
  isFreeOffer?: boolean;
  /**
   * SIAE parity: an offer can only be marked "Approved" once its parent event (admissions) or
   * company (passes) is itself SIAE-approved — admin enforces this server-side. The "Approved"
   * option is disabled when this is false; the save mapper coerces `isSiaeApproved` to false too.
   * Defaults to allowed so callers that don't pass it keep the prior behaviour.
   */
  isSiaeApprovalAllowed?: boolean;
  errors?: RegulationSettingsErrors;
  dataTestId?: string;
}
